import { render, staticRenderFns } from "./SaveStaffName.vue?vue&type=template&id=7a09368d&scoped=true&"
import script from "./SaveStaffName.vue?vue&type=script&lang=ts&"
export * from "./SaveStaffName.vue?vue&type=script&lang=ts&"
import style0 from "./SaveStaffName.vue?vue&type=style&index=0&id=7a09368d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a09368d",
  null
  
)

export default component.exports